import React from 'react';
import { observer } from 'mobx-react-lite';
import { getUrlFromPath } from 'libs/helpers/helper.lib';
import themeStore from 'stores/theme.store';

const DynamicLogo = ({ className, onClick, alt = 'Logo', ...props }) => {
  const colors = themeStore.getColors();
  const darkLogoUrl = themeStore.getDarkLogoUrl();
  const lightLogoUrl = themeStore.getLightLogoUrl();
  
  // Determine which logo to use based on background color
  // If background is dark (low brightness), use light logo
  // If background is light (high brightness), use dark logo
  const isDarkBackground = colors.BACKGROUND_MAIN === '#000000' || 
                          colors.BACKGROUND_MAIN === '#121212' ||
                          colors.BACKGROUND_MAIN.startsWith('#') && 
                          parseInt(colors.BACKGROUND_MAIN.slice(1, 3), 16) < 128;
  
  const logoUrl = isDarkBackground ? lightLogoUrl : darkLogoUrl;

  return (
    <img
      src={getUrlFromPath(logoUrl)}
      alt={alt}
      className={className}
      onClick={onClick}
      onError={(e) => {
        e.target.src = '/logo.png';
      }}
      {...props}
    />
  );
};

export default observer(DynamicLogo);
